var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
    general: {
        // limit: bcSfFilterConfig.custom.products_per_page,
        limit: 18,
        /* Optional */
        loadProductFirst: true
    }
};

function getGridItemTemplate() {
  return document.querySelectorAll('[data-template-for="product-grid-item"]')[0].innerHTML;
}

function handleize(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
}
// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
    'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.label.sorting + '</label><select class="bc-sf-filter-filter-dropdown">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.label.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
    // Grid Template
    'productGridItemHtml': getGridItemTemplate(),
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;
  var itemVariants = '';
  
  itemVariants = theme.ProductSiblings.generateSiblingHtml(data);
  if (itemVariants) {
    itemHtml = itemHtml.replace(/product-grid-item /g, 'product-grid-item product-grid-item--siblings-loaded ');
  }
  
  itemHtml = itemHtml.replace(/{{itemVariants}}/g, itemVariants);
  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  return '';
};

BCSfFilter.prototype.buildProductList = function(data, eventType) {
  if(eventType == "history") return;
  data = this.prepareProductData(data);

  if (this.getSettingValue('general.paginationType') == 'infinite' && eventType == 'page') {
    theme.current.collection.products = _.concat(theme.current.collection.products, data);
  } else {
    theme.current.collection.products = data;
  }

  theme.ProductFilter.buildCollectionPage(data, eventType);
}

/************************** END BUILD PRODUCT LIST **************************/

/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/

// Build additional elements
async function fetchRelatedProducts(data){
  const productStitchingElement = document.querySelector(`.product-stitching[product-id="${data.id}"]`);

  if (productStitchingElement) {
    productStitchingElement.innerHTML = await theme.ProductSiblings.generateSiblingHtml(data);
  } else {
    console.warn(`Element with class 'product-stitching' and product-id '${data.id}' not found.`);
  }
}
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
   for (var product of data.products) {
     fetchRelatedProducts(product);
   }
    var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
    jQ('#bc-sf-filter-total-product').html(totalProduct);
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
    }
    var self = this;
    if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function' && self.queryParams.event_type !== 'init') {
        StampedFn.loadBadges();
    }

    var currentColours = window.bcsffilter.queryParams.pf_t_colour;
    if(currentColours) {
      var lastColour = window.bcsffilter.queryParams.pf_t_colour.slice(-1)[0];
      lastColour = lastColour.replace('colour:', '');
      console.log("*[data-variant-title*='"+lastColour+"']");
      jQ("*[data-variant-title*='"+lastColour.toLowerCase()+"']").click();
    }
};

function buildEmployeeDiscounts(data) {
  if (!window.location.host == 'kr.wilson.com') return;
  if (data.compare_at_price > 0) {
    if ((data.compare_at_price - data.price) > 0) return;
  }
  console.log( "DATA PRICE" , data.price)
  const customer = window.shop.customer;
  if (!customer.is_logged_in) return;
  

  for (let i=0; i<customer.tags.length; i++) {
    let tag = customer.tags[i];
    if (!tag.includes("discount::") && !tag.includes("%") ) continue;

    let tagSplit = tag.split("::");
    let percent = tagSplit[(tagSplit.length-1)].replace("%","");
    percent = percent/100.0;
    let original_price = data.price;
    let disccounted_price = data.price * percent;

    data.price = original_price - disccounted_price;
    data.compare_at_price = original_price;
    data["employee_discount"] = true;
    console.log("data.compare_at_price" , data.compare_at_price)
  }
}

function buildHigherDiscountsBW(data) {
  if (!window.location.host == 'kr.wilson.com') return;
  
  const customer = window.shop.customer;
  if (!customer.is_logged_in) return;
  var birthday_percent= 10;
  var welcome_percent = 10;
  var annual_limit_tag_prefix = 'annual-limit::'
  var annual_expense_tag_prefix = 'annual-expense::'
  var staff_dicount = 'discount::';
  var loyalty_tag_prefix = 'Membership::Tier::';
  var loyalty_gold_percentage = 10;
  var loyalty_silver_percentage = 5;
  var loyalty = false;
  var birthday = false;
  var b_claimed = false;
  var b_expired = false;
  var welcome = false;
  var claimed = false;
  var expired = false;
  var price = data.price;
  var member_discount = 0;

  for (let i=0; i<customer.tags.length; i++) {
    let tag = customer.tags[i];
    if (tag.includes("birthday-discount::created")){
      birthday = true;
    }else if (tag.includes("welcome-discount::created")){
        welcome = true;
    } else if(tag.includes("welcome-discount::claimed")){
        claimed = true;
    }else if( tag.includes("welcome-discount::expired")){
      expired = true;
    }else if(tag.includes("birthday-discount::claimed")){
       b_claimed = true;
    }else if( tag.includes("birthday-discount::expired")){
      b_expired = true;
    }else if( tag.includes(loyalty_tag_prefix)){
      var tier_name = tag.split('::')[2]
      var loyalty_discount = 0
      switch (tier_name) {
        case  "Gold":
          loyalty_discount = loyalty_gold_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        case "Silver":
          loyalty_discount = loyalty_silver_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        default:
          loyalty_discount = 0;
      }
    }else if( tag.includes(staff_dicount) && tag.includes("%")){
        let tagSplit = tag.split("::");
        var staff_percentage = tagSplit[(tagSplit.length-1)].replace("%","");
        // console.log("percent", staff_percentage)

    }else if( tag.includes(annual_limit_tag_prefix) ){
      let tagSplit = tag.split("::")[2];
      // console.log("annual_limit tag", tagSplit)
      var annual_limit = tagSplit;
      // console.log("annual_limit", annual_limit)
    }else if( tag.includes(annual_expense_tag_prefix) ){
      let tagSplit = tag.split("::")[2];
      var annual_expense = tagSplit;
      // console.log("annual_expense", annual_expense)
    }
  }

  if ( annual_expense  && annual_limit  && staff_percentage){
    var memeber_total_left = annual_limit - annual_expense
    if (memeber_total_left > 0 && staff_percentage > 0) {
     var member_qualifies = true
    }
  }


  if ( welcome == true && claimed == false && expired == false){
    if ( welcome_percent > member_discount){
      member_discount = welcome_percent;
    }
      let percent;
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["welcome_discount"] = true;

      // console.log("Welcome qualifies ")
  }
 if(birthday == true && b_claimed == false && b_expired == false ){
  if(birthday_percent > member_discount){
    member_discount = birthday_percent;
  }
    
      let percent;
      percent = member_discount/100.0; 
      let original_price = price;
      let disccounted_price = original_price * percent;
  
      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["birthday_discount"] = true;
   
    // console.log("Birthday  qualifies ")
  }
  
  if(loyalty == true){
    if(loyalty_discount > member_discount){
      member_discount = loyalty_discount;
    }
    percent = member_discount/100.0;
    let original_price = data.price;
    if (data.compare_at_price > 0) {
      original_price = data.compare_at_price;
    }
    let disccounted_price = original_price * percent;

    let standardDiscount = original_price - price;
    let memberDiscount = original_price - disccounted_price;
    if (standardDiscount>disccounted_price) return;

    data.price = memberDiscount;
    data.compare_at_price = original_price;
    data["Loyalty_discount"] = true;
  }

  if (member_qualifies == true){
    if(staff_percentage > member_discount){
      member_discount = staff_percentage;
    }

    percent = member_discount/100.0;
    let original_price = data.price;
    if (data.compare_at_price > 0) {
      original_price = data.compare_at_price;
    }
    let disccounted_price = original_price * percent;

    let standardDiscount = original_price - price;
    let memberDiscount = original_price - disccounted_price;
    console.log("standardDiscount", standardDiscount);
    console.log("disccounted_price", disccounted_price);
    if (standardDiscount>disccounted_price) return;

    data.price = memberDiscount;
    data.compare_at_price = original_price;
    data["Staff_discount"] = true;
  }  
}

function addDummyCustomTags(product) {
  if(!window.badges) return [];
  const {compareAtPrice, price, available} = product;
  const saleTag = addSaleTag(compareAtPrice, price, product);
  const soldOutTag = addSoldOutTag(available, product)
  return [...saleTag, ...soldOutTag]
}

function addSaleTag(compareAtPrice, price, product) {
  if(typeof compareAtPrice === 'undefined' || !compareAtPrice) return []
  if(typeof price === 'undefined') return []
  if(compareAtPrice > price) {
    return [window.badges.config.saleDummyTag]
  }
  return []
}

function addSoldOutTag(available, product) {
  if(typeof available === 'undefined') return []
  const boolAvailable = (available === true)
  if (!boolAvailable) {
    return [window.badges.config.soldOutDummyTag]
  }

  return []
}

function buildBadgesLabels(data) {
  const dummyTags = addDummyCustomTags(data)
  const productTags = data.tags.concat(dummyTags);
  const badgesElement = document.getElementById('product-badges');
  if (!badgesElement) {
    return '';
  }
  const badgesJson = JSON.parse(badgesElement.innerHTML);
  const badges = {
    'topLeft': [],
    'topRight': [],
    'bottomLeft': [],
    'bottomRight': []
  };

  for (let index = 0; index < badgesJson.length; index++) {
    const element = badgesJson[index];
    if (productTags.includes(element.id)) {
      var backgroundColor;
      var textColor;
      var hasCustomStyles = false;
      var styles = "style=\"";
      if (element.background_color != "" && element.background_color != "rgba(0,0,0,0)") {
        backgroundColor = `background-color: ${element.background_color};`;
        hasCustomStyles = true;
        styles += backgroundColor;
      }
      if (element.text_color != "" && element.text_color != "rgba(0,0,0,0)") {
        textColor = `color: ${element.text_color};`;
        hasCustomStyles = true;
        styles += textColor;
      }
      styles += "\"";
      let img = null
      if(element.badge_img != null) {
        img = `<img src="${element.badge_img}" />`
      }
      let html = `<span ${styles} class="badge-inner">${img ? img : element.badge_text}</span>`;
      let position = element.position;
      badges[position].push(html);
    }
  }

  // let badgesHtml = ``;
  // for (pos in badges) {
  //   if (badges[pos].length > 0) {
  //     let value = badges[pos].join("");
  //     badgesHtml += `<div class="badge--wrapper badge--${pos}">${value}</div>`
  //   }
  // }
  // console.log(badges);
  data.badges = badges
  // return badgesHtml;
}

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

/* Customize data to suit the data of Shopify API */
BCSfFilter.prototype.prepareProductData = function(data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]['images'] = data[k]['images_info'];
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0]
      
      if (data[k]['images'].length === 1 && data[k]['original_images'] && data[k]['original_images'].length > 1 ) {
        data[k]['second_image'] = data[k]['original_images'][1]
      } else if(data[k]['images'].length > 1) {
        data[k]['second_image'] = data[k]['images'][1]
      }
    } else {
      data[k]['featured_image'] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: '',
        height: '',
        aspect_ratio: 0
      }
    }
    data[k]['url'] = '/products/' + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]['options_with_values'].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name'])
    }
    data[k]['options'] = optionsArr;
    data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
    data[k]['price'] = data[k]['price_min'];
    data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];
    var firstVariant = data[k]['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function(e) {
        return e.id == getParam('variant')
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      var countVariants = data[k]['variants'].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i];
          break
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant;
    var countVariants = data[k]['variants'].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1])
        }
        data[k]['variants'][i]['options'] = variantOptionArr
      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html'];
    /* Start Multi currency data */
    /* If this store has the multi-currency feature */
    if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
      /* Get the current currency code */
      var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();

      /* Update the product price data */
      data[k].price_min = data[k]['price_min_' + currentCurrency];
      data[k].price_max = data[k]['price_max_' + currentCurrency];
      data[k].compare_at_price_min = data[k]['compare_at_price_min_' + currentCurrency];
      data[k].compate_at_price_max = data[k]['compare_at_price_max_' + currentCurrency];
    }
    /* End Multi currency data */

    buildBadgesLabels(data[k]);
    //buildWelcomeDiscounts(data[k]);
    //buildBirthdayDiscounts(data[k]);
    buildHigherDiscountsBW(data[k]);
    //console.log('data', data[k])
    //buildEmployeeDiscounts(data[k]);
  }
  return data
};
